fragment CourseContentFragment on courseContent_Entry {
  typeHandle
  course
  backgroundGreen
  showChapterNumbers
}
